import React, { forwardRef, useCallback, useImperativeHandle } from 'react';

import useGalleryState from '@rover/react-lib/src/components/ImageGallery/hooks/useGalleryState';
import ImageGallery from '@rover/react-lib/src/components/ImageGallery/ImageGallery';
import type {
  GalleryItem,
  PaginationConfig,
} from '@rover/react-lib/src/components/ImageGallery/ImageGallery.common';

export type SitterProfileGalleryHandle = {
  openLightbox: (index: number) => void;
  openGrid: () => void;
};

type Props = {
  images: GalleryItem[] | undefined;
  pagination?: PaginationConfig;
  renderImageOverlay?: (index: number) => React.ReactNode;
  onViewGallery?: () => void;
};

const SitterProfileGallery = forwardRef<SitterProfileGalleryHandle, Props>(
  ({ images, pagination, renderImageOverlay, onViewGallery }, ref): JSX.Element | null => {
    const { isOpen, openLightbox, openGrid, galleryProps } = useGalleryState();
    const { onViewGallery: showGrid } = galleryProps;

    useImperativeHandle(ref, () => ({ openLightbox, openGrid }), [openLightbox, openGrid]);

    const handleViewGallery = useCallback((): void => {
      showGrid?.();
      onViewGallery?.();
    }, [showGrid, onViewGallery]);

    if (!isOpen) return null;

    return (
      <ImageGallery
        images={images}
        pagination={pagination}
        renderImageOverlay={renderImageOverlay}
        {...galleryProps}
        onViewGallery={handleViewGallery}
      />
    );
  }
);

SitterProfileGallery.displayName = 'SitterProfileGallery';

export default SitterProfileGallery;
